import type { ReactNode } from "react";
import { ELENCO_BOLLETTE, TEMPO_LETTURA, lette as conteggioLette } from "./scritte";

interface Props {
  lette: number;
  totale: number;
  /** Bollette ancora da leggere o file ancora da mandare: si mostra quanto ci vuole. */
  inCorso: boolean;
  children: ReactNode;
}

/** Il blocco «Bollette caricate»: quante lette sul totale e l'elenco delle voci. */
export function CodaCaricamento({ lette, totale, inCorso, children }: Props) {
  const quota = totale > 0 ? lette / totale : 0;
  return (
    <section id={ELENCO_BOLLETTE} className="scroll-mt-14 space-y-2 lg:scroll-mt-0" aria-labelledby="bollette-caricate">
      <div className="flex items-center justify-between gap-3">
        <h3 id="bollette-caricate" className="text-sm font-medium text-text">Bollette caricate</h3>
        {totale > 0 && <p className="text-sm text-muted-foreground tabular-nums">{conteggioLette(lette, totale)}</p>}
      </div>
      {totale > 0 && (
        <div
          role="progressbar"
          aria-labelledby="bollette-caricate"
          aria-valuemin={0}
          aria-valuemax={totale}
          aria-valuenow={lette}
          className="h-2 overflow-hidden rounded-full bg-border"
        >
          <div className="h-full origin-left bg-brand transition-transform duration-300 motion-reduce:transition-none" style={{ transform: `scaleX(${quota})` }} />
        </div>
      )}
      {inCorso && <p className="pb-1 text-xs text-muted-foreground">{TEMPO_LETTURA}</p>}
      <ul aria-label="Bollette caricate" className="space-y-2">{children}</ul>
    </section>
  );
}
